
import { getRequest, postRequest } from '../tools/ajax.js'
import axios from 'axios';
//用章记录
const Seal = params => postRequest('/api/pc/Seal/Seal', params);

//用章详情
const SealDetail= params => postRequest('/api/pc/Seal/SealDetail', params);

//删除用章记录
const SealDel= params => postRequest('/api/pc/Seal/SealUpdate', params);

//用章申请按钮
const SealApply = params => postRequest('/api/pc/Seal/SealApply', params);


//用章详情
const SealDaYin= params => postRequest('/api/pc/Seal/SealDaYin', params);

//测试
const user = params => postRequest('/api/pc/Option/Lawyer', params);

//测试
const allCheckSeal = params => postRequest('/api/pc/Examine/AllCheckSeal', params);

//删除用章记录
const SealDelete= params => getRequest('/api/pc/Seal/SealDelete', params);


// 获取文件
const requestDownLoadFile = params => axios({
    url: '/api/Filer/CaseGet',
    responseType:'blob',
    method: 'get',
    params
})
const requestDownLoadFilePC = params => axios({
    url: '/api/Filer/PcGet',
    responseType:'blob',
    method: 'get',
    params
})

export {
    SealApply,Seal,SealDetail,SealDel,user,requestDownLoadFile,SealDaYin,allCheckSeal,SealDelete,requestDownLoadFilePC
}
// export function SealApply(data) {
//     return request({
//       url: '/api/Seal/SealApply',
//       method: 'post',
//       data
//     })
//   }